import { useState } from "react";

import { usePurchaseFlowAnchorProps } from "@/react/helpers/purchaseFlowAnchor";
import { useAnyHoverMediaQuery } from "@/react/hooks/useMediaQuery";

import { SidebarItem } from "../SidebarItem";
import { LinkOptionsMenu } from "./LinkOptionsMenu";

export interface SidebarLink {
  id: number;
  may_lead_to_purchase: boolean;
  name: string;
  url: string;
}

export interface LinkItemProps {
  isAdmin?: boolean;
  link: SidebarLink;
}

export const LinkItem = ({ isAdmin = false, link }: LinkItemProps) => {
  const canHover = useAnyHoverMediaQuery();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const purchaseFlowAnchorProps = usePurchaseFlowAnchorProps(
    link.may_lead_to_purchase,
  );

  return (
    <SidebarItem
      rootElement={
        <a
          href={link.url}
          target="_blank"
          rel="noreferrer noopener"
          draggable="false"
          title={link.name}
          {...purchaseFlowAnchorProps}
        />
      }
      hoverScope="scoped"
    >
      <SidebarItem.Content
        label={link.name}
        startIcon="arrow-up-right"
        endContent={
          isAdmin && (
            <LinkOptionsMenu link={link} onOpenChange={setIsMenuOpen} />
          )
        }
        showEndContentOnlyOnHover={canHover && !isMenuOpen}
      />
    </SidebarItem>
  );
};
